module.exports = __webpack_public_path__ + "32f738dc308cee7993afb01d457b28b2.png";